/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/ugc-notification/getters';
import {actions} from '@/store/modules/ugc-notification/actions';
import {mutations} from '@/store/modules/ugc-notification/mutations';
import {UgcNotificationStateInterface} from '@/store/modules/ugc-notification/types';

/**
 * The UGC notification store module.
 *
 * The UGC notification store represents a set of user notification items.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export const state: UgcNotificationStateInterface = {
    items: [],
};

const namespaced: boolean = true;

export const ugcNotificationModule: Module<UgcNotificationStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
